module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "loginless-layout",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "offset-md5": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "indigo",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (!!_vm.$slots['media']) ? _c('v-card-media', [_vm._t("media")], 2) : _vm._e(), _vm._v(" "), _c('v-card-text', [_vm._t("default")], 2), _vm._v(" "), (!!_vm.$slots['actions']) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-324d784e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginlessLayout.vue
// module id = 1065
// module chunks = 1